import styled from "styled-components";

export const EventCardWrapper = styled.div`
  .event-card {
    position: relative;
    background-color: rgba(0, 67, 255, 0.95);
  }
`;

export const EventProgramWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 60px;
  background: #fafbff;
  padding: 60px 0 105px 0;
  .event-program-item {
    margin-bottom: 20px;
    :last-child {
      margin-bottom: 0;
    }
  }
  @media (max-width: 768px) {
    margin-top: 40px;
    padding: 30px 0 40px 0;
    .event-program-item {
      margin-bottom: 10px;
    }
  }
`;

export const EventProgramLabel = styled.h2`
  margin-bottom: 60px;
  @media (max-width: 768px) {
    margin-bottom: 10px;
  }
`;

export const CtaWrapper = styled.div`
  background: #0043ff;
  padding: 55px 0;
  color: #fafbff;
  font-size: 2.5rem;
  text-align: center;
  @media (max-width: 768px) {
    font-size: 1.1rem;
    padding: 30px 0;
  }
`;

export const Text = styled.div`
  font-size: 3.33rem;
  line-height: 5rem;
  margin-bottom: 40px;
  padding: 0 125px;
  @media (max-width: 768px) {
    padding: 0 20px;
    font-size: 1.2rem;
    line-height: 1.8rem;
    margin-bottom: 15px;
  }
`;

export const SubText = styled.div`
  margin-bottom: 60px;
  padding: 0 125px;
  @media (max-width: 768px) {
    padding: 0 20px;
    margin-bottom: 15px;
  }
`;

export const ContactInfos = styled.div`
  display: flex;
  flex-direction: column;
  span {
    margin-top: 20px;
    @media (max-width: 768px) {
      margin-top: 4px;
    }
  }
`;

export const Email = styled.span`
  text-decoration: underline;
`;
